<template>
  <div
    :style="[colorData.colorStyles]"
    :class="[colorData.colorClasses]"
    class="graph-data-value"
  >
    <!--
      `splitNumber` insere des espaces insecables tous les trois chiffres. Sans
      lui, une tresorerie s'affichait -25976843 € dans l'infobulle.
    -->
    {{ value | splitNumber }} {{ unit }}
  </div>
</template>

<script>
import { getTextColorData } from './colorUtils'

export default {
  name: 'GraphDataValue',

  props: {
    value: {
      type: Number,
      required: true
    },
    unit: {
      type: String,
      default: null
    },
    positiveColor: {
      type: String,
      default: 'success'
    },
    negativeColor: {
      type: String,
      default: 'warning'
    }
  },

  computed: {
    colorData () {
      return getTextColorData(this.value >= 0 ? this.positiveColor : this.negativeColor)
    }
  }
}
</script>

<style lang="scss" scoped>
.graph-data-value {
  font-size: 1.25rem !important;
  font-weight: 500;
  line-height: 1.6;
}
</style>
